/**
 * Image constants
 */

// Path to the fallback image
export const PLACEHOLDER_IMAGE_PATH = '/images/products/default.png'
